import type { TOC } from '@ember/component/template-only';

import GenieFullScreenComponent from 'webapp/components/genie/full-screen/index';
import type GenieChatController from 'webapp/controllers/genie/chat';

interface Args {
	controller: GenieChatController;
}

const GenieChatRouteTemplate: TOC<Args> = <template>
	<GenieFullScreenComponent
		@contextItems={{@controller.contextItems}}
		@initialMessages={{@controller.initialMessages}}
		@initialPrompt={{@controller.initialPrompt}}
		@selectedAccountIds={{@controller.selectedAccountIds}}
		@chatMode={{@controller.chatMode}}
		@threadId={{@controller.threadId}}
		@artifactId={{@controller.artifactId}}
		@onboardingLeave={{@controller.onboardingLeave}}
	/>
	{{outlet}}
</template>;

export default GenieChatRouteTemplate;
